import styled, { css } from 'styled-components';

import { Color, FontFamily, FontSize, FontWeight, Spacing } from '~/src/atomic/obj.constants';

export const HDisplay = styled.label`
  color: ${Color.Black};
  font-size: ${FontSize.Large};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Medium};
`;
HDisplay.displayName = 'HDisplay';

export const H1 = styled.h1`
  color: ${Color.Black};
  font-size: ${FontSize.Large};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Medium};
  margin-bottom: ${Spacing.Medium};
  margin-top: ${Spacing.Medium};
  text-align: center;
`;

export const H2 = styled.h2`
  color: ${Color.Black};
  font-size: ${FontSize.Large};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Medium};
  margin-bottom: ${Spacing.Medium};
  margin-top: ${Spacing.Large};
`;
H2.displayName = 'H2';

export const H3Height = FontSize.Medium;
export const H3 = styled.h3`
  color: ${Color.GrayXDark};
  font-size: ${H3Height};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Bold};
`;
H3.displayName = 'H3';

export const H4Height = FontSize.Small;
export const H4 = styled.h4`
  color: ${Color.GrayXDark};
  font-size: ${H4Height};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Bold};
  line-height: 1.5;
  margin-top: 0;
  margin-bottom: ${Spacing.XSmall};
`;
H4.displayName = 'H4';

export const Body = styled.p`
  margin: 0;
  color: ${Color.GrayXDark};
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.Secondary};
  font-weight: ${FontWeight.Normal};
  line-height: 1.5;
`;
Body.displayName = 'Body';

export const BodySecondary = styled.label`
  margin: 0;
  color: ${Color.GrayDark};
  font-size: ${FontSize.XSmall};
  font-family: ${FontFamily.Secondary};
  font-weight: ${FontWeight.Normal};
  line-height: 1.5;
`;

export const BodySecondaryCentered = styled(BodySecondary)`
  text-align: center;
`;

interface InputLabelProps {
  hasError?: boolean;
}

export const InputLabel = styled.label<InputLabelProps>`
  color: ${(props) => (props.hasError ? Color.Alert : Color.GrayXDark)};
  display: block;
  font-size: ${FontSize.XSmall};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Normal};
  margin-bottom: ${Spacing.XSmall};
  line-height: 1.5;
`;

export const InputValueCss = css`
  color: ${Color.Black};
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.Secondary};
  font-weight: ${FontWeight.Normal};
`;

export const InputValue = styled.label`
  ${InputValueCss};
`;

export const InputDisabledCss = css`
  ${InputValueCss}
  color: ${Color.Gray};

  /* https://stackoverflow.com/a/45209441/3670829 */
  -webkit-text-fill-color: ${Color.Gray};
  opacity: 1;
  -webkit-opacity: 1;
`;

export const InputDisabled = styled.label`
  ${InputDisabledCss};
`;

export const InputCaption = styled.label`
  color: ${Color.GrayXDark};
  font-size: ${FontSize.XSmall};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Normal};
  margin-top: ${Spacing.Small};
  display: block;
`;

export const InputCaptionError = styled(InputCaption)`
  color: ${Color.Alert};
`;

export const InputPlaceholderCss = css`
  ${InputValueCss}
  color: ${Color.GrayDark};
  opacity: 1;
`;

export const InputPlaceholder = styled.label`
  pointer-events: none;
  ${InputPlaceholderCss};
`;

export const ProductPricePrefix = styled.span`
  color: ${Color.GrayDark};
  font-weight: ${FontWeight.Bold};
`;

export interface PriceProps {
  isFeatured?: boolean;
}

export const ProductPrice = styled.label<PriceProps>`
  color: ${(props) => (props.isFeatured ? Color.Alert : Color.Primary)};
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Medium};
`;

export const ProductOldPrice = styled.label`
  color: ${Color.GrayDark};
  text-decoration: line-through;
  font-size: ${FontSize.XSmall};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Normal};
`;

export const DT = styled.dt`
  display: inline;
  color: ${Color.GrayXDark};
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Bold};
`;

export const DD = styled.dd`
  display: inline;
  color: ${Color.Black};
  font-size: ${FontSize.Medium};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Bold};
  margin: 0;
`;

export const LinkText = styled.span`
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Medium};
  font-size: ${FontSize.Small};
  text-decoration: none;
  pointer-events: pointer;
  color: ${Color.PrimaryDark};
`;

// Utilities

export const Ellipsed = styled.span`
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TextCenter = styled.div`
  text-align: center;
`;

export const TextWhite = styled.span`
  color: ${Color.White};
`;

export const TextPrimaryLight = styled.span`
  color: ${Color.PrimaryLight};
`;
